/* ================================================================
   FRANK.JS — Interactions for Frank landing page + blog articles
   Vintage Visual · 2026
   ================================================================ */

(function () {
  'use strict';

  /* ── UTM capture (first-touch, session-scoped) ─────────────────── */
  var UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
  var frankUtm = {};
  try {
    var params = new URLSearchParams(window.location.search);
    UTM_KEYS.forEach(function (k) {
      var v = params.get(k);
      if (v) frankUtm[k] = v;
    });
    if (Object.keys(frankUtm).length) {
      sessionStorage.setItem('frank_utm', JSON.stringify(frankUtm));
    } else {
      var saved = sessionStorage.getItem('frank_utm');
      if (saved) frankUtm = JSON.parse(saved) || {};
    }
  } catch (e) { /* sessionStorage blocked — fall through with empty utm */ }

  /* ── Reveal on scroll ──────────────────────────────────────────── */
  var revealIO = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) {
        e.target.classList.add('in');
        revealIO.unobserve(e.target);
      }
    });
  }, { threshold: 0.12 });

  document.querySelectorAll('.frank-reveal').forEach(function (el) {
    revealIO.observe(el);
  });

  /* ── Specs section: staggered group reveal ─────────────────────── */
  var specsSection = document.getElementById('specs');
  var specGroups = document.querySelectorAll('.frank-specs-group');

  if (specsSection && specGroups.length) {
    var specsIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          specGroups.forEach(function (g) { g.classList.add('in'); });
          specsIO.unobserve(e.target);
        }
      });
    }, { threshold: 0.1 });
    specsIO.observe(specsSection);
  }

  /* ── Specs video: play on scroll, pause when out ───────────────── */
  var specsVid = document.getElementById('frank-specs-video');
  if (specsVid) {
    specsVid.playbackRate = 0.8;
    var vidIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { specsVid.play(); } else { specsVid.pause(); }
      });
    }, { threshold: 0.15 });
    vidIO.observe(specsVid);
  }

  /* ── Solution video: muted, plays once when scrolled into view ─── */
  var solutionVid = document.getElementById('frank-solution-video');
  if (solutionVid) {
    var solutionIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var played = solutionVid.play();
        if (played && typeof played.catch === 'function') {
          played.catch(function () { /* autoplay blocked — poster stays */ });
        }
        solutionIO.unobserve(e.target);
      });
    }, { threshold: 0.35 });
    solutionIO.observe(solutionVid);
  }

  /* ── Contact modal ─────────────────────────────────────────────── */
  var modal = document.getElementById('frank-contact-modal');
  if (modal) {
    /* Open buttons */
    document.querySelectorAll('[data-frank-contact]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        modal.classList.add('is-open');
      });
    });

    /* Close on overlay click */
    var overlay = modal.querySelector('.frank-modal-overlay');
    if (overlay) {
      overlay.addEventListener('click', function () {
        modal.classList.remove('is-open');
      });
    }

    /* Close button */
    var closeBtn = modal.querySelector('.frank-modal-close');
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        modal.classList.remove('is-open');
      });
    }

    /* Close on Escape */
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') modal.classList.remove('is-open');
    });

    /* Contact form — AJAX submit to Shopify */
    var contactForm = modal.querySelector('form');
    if (contactForm) {
      contactForm.addEventListener('submit', function (e) {
        e.preventDefault();
        var fields = contactForm.querySelector('.frank-modal-fields');
        var thanks = contactForm.querySelector('.frank-modal-thanks');
        var submitBtn = contactForm.querySelector('.frank-modal-submit');

        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.textContent = modal.getAttribute('data-t-sending') || 'Sending...';
        }

        var formData = new FormData(contactForm);

        fetch(contactForm.action || '/contact', {
          method: 'POST',
          body: formData,
          headers: { 'Accept': 'text/html' }
        }).then(function () {
          if (fields && thanks) {
            fields.style.display = 'none';
            thanks.style.display = 'block';
          }
        }).catch(function () {
          if (fields && thanks) {
            fields.style.display = 'none';
            thanks.style.display = 'block';
          }
        });
      });
    }
  }

  /* ── Klaviyo signup form ───────────────────────────────────────── */
  var signupForm = document.getElementById('frank-signup-form');
  if (signupForm) {
    signupForm.addEventListener('submit', function (e) {
      e.preventDefault();

      var email = signupForm.querySelector('input[name="email"]').value.trim();
      var firstName = signupForm.querySelector('input[name="first_name"]').value.trim();
      var checks = signupForm.querySelectorAll('input[name="format"]:checked');
      var formats = [];
      checks.forEach(function (c) { formats.push(c.value); });

      if (!email) return;

      var submitBtn = signupForm.querySelector('.frank-signup-submit');
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = signupForm.getAttribute('data-t-busy') || 'Signing up...';
      }

      /* Resolve source tagging from captured UTMs */
      var utmSource = (frankUtm.utm_source || 'direct').toLowerCase();
      var customSource = 'Frank: ' + utmSource;

      /* Build profile attributes */
      var profileAttrs = {
        email: email,
        properties: { Frank_Signup: true, Frank_Source: utmSource }
      };
      if (firstName) profileAttrs.first_name = firstName;
      if (formats.length) profileAttrs.properties.Film_Formats = formats;
      if (frankUtm.utm_medium)   profileAttrs.properties.Frank_Medium   = frankUtm.utm_medium;
      if (frankUtm.utm_campaign) profileAttrs.properties.Frank_Campaign = frankUtm.utm_campaign;
      if (frankUtm.utm_content)  profileAttrs.properties.Frank_Content  = frankUtm.utm_content;
      if (frankUtm.utm_term)     profileAttrs.properties.Frank_Term     = frankUtm.utm_term;

      /* Klaviyo Client API — subscribe to list */
      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=THuhPP', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'revision': '2024-10-15'
        },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              custom_source: customSource,
              profile: {
                data: {
                  type: 'profile',
                  attributes: profileAttrs
                }
              }
            },
            relationships: {
              list: {
                data: {
                  type: 'list',
                  id: 'Uc8ZUZ'
                }
              }
            }
          }
        })
      }).then(function (res) {
        if (res.ok || res.status === 202) {
          var fields = signupForm.querySelector('.frank-signup-fields');
          var thanks = signupForm.querySelector('.frank-signup-thanks');
          if (fields && thanks) {
            fields.style.display = 'none';
            thanks.style.display = 'block';
          }
          /* Track signup in Plausible (with source for goal breakdown) */
          if (typeof plausible === 'function') {
            plausible('frank_signup', { props: { source: utmSource } });
          }
        } else {
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.textContent = signupForm.getAttribute('data-t-default') || 'Sign Me Up';
          }
        }
      }).catch(function () {
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.textContent = signupForm.getAttribute('data-t-default') || 'Sign Me Up';
        }
      });
    });
  }

  /* ── Campaign countdown (hero + Indiegogo strip) ───────────────── */
  (function initFrankCountdowns() {
    var nodes = document.querySelectorAll('[data-frank-countdown]');
    if (!nodes.length) return;

    function pad(n) { return (n < 10 ? '0' : '') + n; }
    /* Text comes from data-* attributes rendered in Liquid (locale keys vv.frank.countdown.*); English is the fallback. */
    function txt(root, name, fallback) { return root.getAttribute('data-' + name) || fallback; }

    function fmtCest(d) {
      try {
        var loc = (document.documentElement.lang || 'en').slice(0, 2);
        if (loc === 'en') loc = 'en-GB';
        return new Intl.DateTimeFormat(loc, {
          weekday: 'long', day: 'numeric', month: 'long',
          hour: '2-digit', minute: '2-digit', hour12: false,
          timeZone: 'Europe/Berlin'
        }).format(d);
      } catch (e) { return d.toUTCString(); }
    }

    var timers = [];
    nodes.forEach(function (root) {
      var launch = new Date(root.getAttribute('data-launch'));
      var end = new Date(root.getAttribute('data-end'));
      if (isNaN(launch.getTime()) || isNaN(end.getTime())) return;
      timers.push({
        root: root, launch: launch, end: end,
        label: root.querySelector('[data-cd-label]'),
        when: root.querySelector('[data-cd-when]'),
        cta: root.querySelector('[data-cd-cta-label]'),
        days: root.querySelector('[data-cd="days"]'),
        hours: root.querySelector('[data-cd="hours"]'),
        mins: root.querySelector('[data-cd="mins"]'),
        secs: root.querySelector('[data-cd="secs"]')
      });
    });
    if (!timers.length) return;

    function setClock(t, ms) {
      var s = Math.floor(Math.max(0, ms) / 1000);
      var d = Math.floor(s / 86400); s -= d * 86400;
      var h = Math.floor(s / 3600); s -= h * 3600;
      var m = Math.floor(s / 60); s -= m * 60;
      if (t.days) t.days.textContent = pad(d);
      if (t.hours) t.hours.textContent = pad(h);
      if (t.mins) t.mins.textContent = pad(m);
      if (t.secs) t.secs.textContent = pad(s);
    }

    function render() {
      var now = Date.now();
      timers.forEach(function (t) {
        if (now < t.launch.getTime()) {
          t.root.setAttribute('data-state', 'pre');
          setClock(t, t.launch.getTime() - now);
          if (t.label) t.label.textContent = txt(t.root, 'lbl-pre', 'Backing opens in');
          if (t.cta) t.cta.textContent = txt(t.root, 'cta-pre', 'Follow on Indiegogo');
          /* Pre-launch: keep the Liquid-rendered "Opens ... EEST (UTC)" line. */
        } else if (now < t.end.getTime()) {
          t.root.setAttribute('data-state', 'live');
          setClock(t, t.end.getTime() - now);
          if (t.label) t.label.textContent = txt(t.root, 'lbl-live', 'Backing closes in');
          if (t.cta) t.cta.textContent = txt(t.root, 'cta-live', 'Back Fränk on Indiegogo');
          if (t.when) t.when.textContent = txt(t.root, 'when-live', 'Live now · closes __DATE__ CEST').replace('__DATE__', fmtCest(t.end));
        } else {
          t.root.setAttribute('data-state', 'ended');
          setClock(t, 0);
          if (t.label) t.label.textContent = txt(t.root, 'lbl-ended', 'Campaign closed');
          if (t.cta) t.cta.textContent = txt(t.root, 'cta-ended', 'View on Indiegogo');
          if (t.when) t.when.textContent = txt(t.root, 'when-ended', 'The Indiegogo campaign has ended. Thank you.');
        }
      });
    }

    render();
    setInterval(render, 1000);
  })();
})();
